const HomeMain: React.FC = () => <Outlet />;
export default HomeMain;
